export default __webpack_public_path__ + "static/media/b64test.9009d5e6.txt";